import { LoginConfig } from 'app/main/auth/login/LoginConfig';
import { RegisterConfig } from 'app/main/auth/register/RegisterConfig';
import { ForgotPasswordPageConfig } from 'app/main/auth/forgot-password/ForgotPasswordPageConfig';
import { ResetPasswordPageConfig } from 'app/main/auth/reset-password/ResetPasswordPageConfig';

export const AuthConfigs = [
    LoginConfig, 
    RegisterConfig,
    ForgotPasswordPageConfig,
    ResetPasswordPageConfig,
];
